import { useTranslation } from "react-i18next";
import usePermissions from "../../permissions/usePermissions";
import { MenuItem } from "@mui/material";
import React from "react";
import { NavigationEntry } from "../Navigation";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";

export default function NavigationMenuItem({ item, onOptionClick }: { item: NavigationEntry; onOptionClick?: () => void }) {
    const { t } = useTranslation();
    const { hasAtLeastOnePermissionOrEmpty } = usePermissions();
    const navigate = useNavigate();
    if (!item?.divider) {
        const { link, title, permissionsAtLeastOne } = item;
        if (!hasAtLeastOnePermissionOrEmpty(permissionsAtLeastOne)) {
            return null;
        }
        return (
            <MenuItem
                key={link}
                onMouseDown={(event) => {
                    if (event.button === 1) {
                        window.open(link, "_blank");
                        onOptionClick?.();
                    }
                }}
                onClick={() => {
                    onOptionClick?.();
                    navigate(link);
                }}
            >
                {t(title)}
            </MenuItem>
        );
    }
    return <Divider />;
}
